import { shopifyGidSchema, ShopifyIdType } from "@redotech/shopify-util/id";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import {
  CountryCodeSchema,
  MoneySchema,
  UnitPriceMeasurementMeasuredUnitSchema,
  WeightSchema,
} from "../common-schemas";
import { ShopifyMetafieldSchema } from "./common";
import {
  ShopifyListingMediaSchema,
  ShopifyListingMediaWithoutRedoIds,
} from "./shopify-media";

export enum ShopifyInventoryPolicyEnum {
  CONTINUE = "CONTINUE",
  DENY = "DENY",
}
export const ShopifyInventoryPolicySchema = createEnum(
  ShopifyInventoryPolicyEnum,
);

const ShopifyListingSelectedOptionSchema_ = z.object({
  name: z.string(),
  value: z.string(),
});
export const ShopifyListingSelectedOptionSchema: z.ZodType<ShopifyListingSelectedOption> =
  ShopifyListingSelectedOptionSchema_;
export interface ShopifyListingSelectedOption
  extends z.infer<typeof ShopifyListingSelectedOptionSchema_> {}

const UnitPriceMeasurementSchema_ = z.object({
  measuredType: z.string().nullable(),
  quantityUnit: UnitPriceMeasurementMeasuredUnitSchema.nullable(),
  quantityValue: z.number(),
  referenceUnit: UnitPriceMeasurementMeasuredUnitSchema.nullable(),
  referenceValue: z.number(),
});
export const UnitPriceMeasurementSchema: z.ZodType<UnitPriceMeasurement> =
  UnitPriceMeasurementSchema_;
export interface UnitPriceMeasurement
  extends z.infer<typeof UnitPriceMeasurementSchema_> {}

const InventoryItemSchema_ = z.object({
  countryCodeOfOrigin: CountryCodeSchema.nullable(),
  hsCode: z.string().nullable(),
  weight: WeightSchema.nullable(),
  requiresShipping: z.boolean(),
});
export const InventoryItemSchema: z.ZodType<InventoryItem> =
  InventoryItemSchema_;
export interface InventoryItem extends z.infer<typeof InventoryItemSchema_> {}

const ShopifyListingVariantSchema_ = z.object({
  id: z.string(),
  productId: z.string().nullable(),
  shopifyVariantId: shopifyGidSchema(ShopifyIdType.ProductVariant).nullable(),
  displayName: z.string(),
  title: z.string(),
  sku: z.string().nullable(),
  barcode: z.string().nullable(),
  inventoryPolicy: ShopifyInventoryPolicySchema,
  price: z.number(),
  compareAtPrice: z.number().nullable(),
  inventoryItem: InventoryItemSchema,
  unitPrice: MoneySchema.nullable(),
  showUnitPrice: z.boolean().nullable(),
  unitPriceMeasurement: UnitPriceMeasurementSchema.nullable(),
  selectedOptions: z.array(ShopifyListingSelectedOptionSchema),
  media: z.array(ShopifyListingMediaSchema),
  metafields: z.array(ShopifyMetafieldSchema),
  taxable: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const ShopifyListingVariantSchema: z.ZodType<ShopifyListingVariant> =
  ShopifyListingVariantSchema_;
export interface ShopifyListingVariant
  extends z.infer<typeof ShopifyListingVariantSchema_> {}

export type ShopifyVariantListingWithoutRedoIds = Omit<
  ShopifyListingVariant,
  "id" | "productId" | "media"
> & { media: ShopifyListingMediaWithoutRedoIds[] };
